/**
 * Templates messages — port fidèle de constants/messages.ts du RG original.
 * 3 messages prêts à l'emploi. Si l'admin les édite depuis Réglages,
 * ils sont sauvegardés en base et priment sur ces défauts.
 */
export const MESSAGES = {
  confirmation: {
    title: "Réservation confirmée",
    body: `Hello🙂‍↔️,

C'est Eva du Curieux Refuge

Je vous contacte par ici afin de fluidifier nos échanges.

Je vous remets ici le guide et les expériences du refuge 🙂

LE GUIDE DU REFUGE
https://bit.ly/CurieuxRefugeGuide

LES EXPÉRIENCES DU REFUGE
https://romance-decors.emergent.host

Nous pouvons échanger si besoin de quoi que ce soit ☺️

À très bientôt au refuge.`,
  },
  arrivee: {
    title: "Jour J · code arrivée",
    body: `Hello, c'est Eva du Curieux Refuge 🙂

C'est le jour J…

Voici l'essentiel pour votre arrivée :

🔑 Accès autonome à partir de *16h*
📍 21 rue des Pêches Cavale, Saint-Gilles-les-Bains
🔗 https://bit.ly/CurieuxRefugeAdresse

🔐 Code de la boîte à clés : *8881*

⸻

Je vous remets ici le guide du refuge avec toutes les informations utiles :
🔗 https://bit.ly/CurieuxRefugeGuide

⸻

Je reste disponible jusqu'à 21h pour toute question. 😉
(et bien sûr en cas d'urgence à tout moment)

Je vous souhaite une très belle arrivée ✨`,
  },
  merci: {
    title: "Merci · avis",
    body: `Bonjour 😊,

Un grand merci pour votre venue au Curieux Refuge 🌿

Si le cœur vous en dit, vous pouvez partager votre expérience ici 🥰
https://g.page/r/CaxMmWbW369lEAE/review

✨ Qu'avez-vous le plus aimé lors de votre séjour ?

Peut-être un moment particulier, une ambiance, ou simplement votre ressenti au Curieux Refuge à Saint-Gilles… 🌙

Merci pour votre confiance,
et que la vie vous soit douce et pleine de magie 🌸`,
  },
};
